import React from 'react';
import { MdStar } from 'react-icons/md';
import './ImageGenerationLoader.css';

const ImageGenerationLoader: React.FC = () => {
  return (
    <div className="image-gen-loader">

      <div className="star star-1" />
      <div className="star star-2" />
      <div className="star star-3" />
      <div className="star star-4" />
      <div className="star star-5" />
      <div className="star star-6" />
      <div className="star star-7" />
      <div className="star star-8" />

      {/* Icon stars (react-icons) */}
      <MdStar size={8}  className="icon-star icon-star-1" />
      <MdStar size={6}  className="icon-star icon-star-2" />
      <MdStar size={10} className="icon-star icon-star-3" />
      <MdStar size={7}  className="icon-star icon-star-4" />
      <MdStar size={9}  className="icon-star icon-star-5" />
      <MdStar size={6}  className="icon-star icon-star-6" />
      <MdStar size={8}  className="icon-star icon-star-7" />
      <MdStar size={7}  className="icon-star icon-star-8" />


      {/* Nebula glow */}
      <div className="ambient-glow" />

      {/* Floating particles */}
      <div className="particle particle-1" />
      <div className="particle particle-2" />
      <div className="particle particle-3" />
      <div className="particle particle-4" />
      <div className="particle particle-5" />
      <div className="particle particle-6" />

      {/* Exhaust fumes */}
      <div className="fume fume-1" />
      <div className="fume fume-2" />
      <div className="fume fume-3" />
      <div className="fume fume-4" />
      <div className="fume fume-5" />
      <div className="fume fume-6" />

      {/* Rocket animation — exact original structure */}
      <div>
        <div className="loader">
          <span>
            <span />
            <span />
            <span />
            <span />
          </span>
          <div className="base">
            <span />
            <div className="face" />
          </div>
        </div>
        <div className="longfazers">
          <span />
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
};

export default ImageGenerationLoader;
